export interface IJWTPayload {
  auth: string;
  exp: number;
  sub: string;
  userId: string;
}

export class JWT {
  token: string;

  constructor(token: string) {
    this.token = token;
  }
  /**
   * Get the payload of the token.
   */
  public getPayload(): IJWTPayload {
    return JSON.parse(atob(this.token.split('.')[1]));
  }

  /**
   * Get the expiration date of the token.
   */
  public getTokenExpiration(): number {
    const payload = this.getPayload();
    return payload.exp * 1000; // Converti il valore in millisecondi
  }
}
